import { Collapse, Form } from 'antd';
import React from 'react';
import UrlInput from '../shared/UrlInput';
import { CompetitorInputState } from './types';

const { Panel } = Collapse;

const defaultUrlSchema = 'https://';

type Props = {
    competitors: Record<number, CompetitorInputState>;
    competitorsValidation: string[];
    maxCompetitors: number;
    onCompetitorsChange: (index: number, newDomain: string, newUrlSchema: string) => void;
};

export default function CompetitorsInput({ competitors, competitorsValidation, maxCompetitors, onCompetitorsChange }: Props) {
    const handleCompetitorUrlChange = (index: number) => (domain: string, urlSchema: string) => {
        onCompetitorsChange(index, domain, urlSchema);
    };

    return (
        <Collapse>
            <Panel
                header="Add competitors (optional)"
                key="1"
            >
                {[...Array(maxCompetitors)].map((_, index) => (
                    <div
                        key={index}
                        className="competitor-item"
                    >
                        <span>{`Competitor ${index + 1}`}</span>
                        <Form.Item
                            validateStatus={competitorsValidation[index] ? 'error' : 'validating'}
                            help={competitorsValidation[index]}
                        >
                            <UrlInput
                                id={`competitor_${index}`}
                                placeholder="Competitor URL"
                                urlSchema={competitors[index]?.urlSchema || defaultUrlSchema} // The competitor at this index might not exist in the competitors object
                                domain={competitors[index]?.domain || ''}
                                onUrlChange={handleCompetitorUrlChange(index)}
                            />
                        </Form.Item>
                    </div>
                ))}
            </Panel>
        </Collapse>
    );
}
